module.exports = __webpack_public_path__ + "img/電気回路_3_2_2.4500fecb.png";